// extracted by mini-css-extract-plugin
module.exports = {"logo":"siteLogo-module--logo--31fib","logoContainer":"siteLogo-module--logoContainer--3n-Ap","name":"siteLogo-module--name--Qk8om"};